import { render, staticRenderFns } from "./Tiers.vue?vue&type=template&id=b8e5e89e&"
import script from "./Tiers.vue?vue&type=script&lang=ts&"
export * from "./Tiers.vue?vue&type=script&lang=ts&"
import style0 from "./Tiers.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports